import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useAuth } from '../../contexts/AuthContext';
import ImageUpload from '../../common/ImageUpload';

const { FiUser, FiMail, FiPhone, FiCheck } = FiIcons;

const ProfileSettings = () => {
  const { user, updateProfile } = useAuth();
  const [formData, setFormData] = useState({
    name: user?.name || '',
    email: user?.email || '',
    phone: user?.phone || '',
    avatar: user?.avatar || ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [saveSuccess, setSaveSuccess] = useState(false);

  useEffect(() => {
    if (user) {
      setFormData({
        name: user.name || '',
        email: user.email || '',
        phone: user.phone || '',
        avatar: user.avatar || ''
      });
    }
  }, [user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    await updateProfile(formData);
    setIsLoading(false);
    setSaveSuccess(true);
    setTimeout(() => setSaveSuccess(false), 3000);
  };

  return (
    <div className="space-y-10">
      <div className="flex justify-between items-start">
        <div>
          <h2 className="text-3xl font-black text-slate-900 tracking-tighter mb-2">My Profile</h2>
          <p className="text-slate-400 font-medium">Manage your personal account information.</p>
        </div>
        {saveSuccess && (
          <motion.div initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} className="bg-green-500 text-white px-4 py-2 rounded-xl text-xs font-black flex items-center gap-2">
            <SafeIcon icon={FiCheck} /> Profile Updated
          </motion.div>
        )}
      </div>

      <form onSubmit={handleSubmit} className="space-y-10">
        <div className="flex flex-col md:flex-row gap-10 items-start">
          <ImageUpload 
            value={formData.avatar} 
            onChange={(url) => setFormData({ ...formData, avatar: url })} 
            label="Profile Picture"
          />
          
          <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-6 w-full">
            <div>
              <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest pl-1">Full Name</label>
              <input required className="w-full p-4 bg-slate-50 border border-slate-100 rounded-2xl outline-none font-bold" value={formData.name} onChange={e => setFormData({ ...formData, name: e.target.value })} />
            </div>
            <div>
              <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest pl-1">Email Address</label>
              <input type="email" disabled className="w-full p-4 bg-slate-50 border border-slate-100 rounded-2xl outline-none font-bold opacity-60" value={formData.email} />
            </div>
            <div>
              <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest pl-1">Phone Number</label>
              <input className="w-full p-4 bg-slate-50 border border-slate-100 rounded-2xl outline-none font-bold" value={formData.phone} onChange={e => setFormData({ ...formData, phone: e.target.value })} />
            </div>
          </div>
        </div>

        <button type="submit" disabled={isLoading} className="w-full bg-blue-600 text-white py-5 rounded-[2rem] font-black shadow-xl shadow-blue-100 hover:bg-blue-700 transition-all disabled:opacity-50">
          {isLoading ? 'Saving Changes...' : 'Update Profile'}
        </button>
      </form>
    </div>
  );
};

export default ProfileSettings;